import React, { useState} from 'react';

function Menu () {

const [isMenuOpen, setIsMenuOpen] = useState(false);
    const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
};
    const closeMenu = () => {
        setIsMenuOpen(false);
    };

    return (
        <> 
            <button className="menu-toggle" onClick={toggleMenu}>  
                ☰
            </button>
            <nav className={`nav-menu ${isMenuOpen ? 'open' : ''}`}>
                <a href="/" onClick={closeMenu}>Главная</a>
                <a href="#more-music" onClick={closeMenu}>Музыка</a>
                <a href="#more-band" onClick={closeMenu}>Группа</a>
                <a href="#press" onClick={closeMenu}>В прессе</a>
                <a href="#contact" onClick={closeMenu}>Контакты</a>
              {/*   <a href="#contact">Contact</a> */}
            </nav>
            {isMenuOpen && <div className="menu-backdrop" onClick={closeMenu}></div>}
            </>

    )
}

export default Menu;

